<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回 </a-button>
      <span class="ml15 card_title" v-if='$route.query.type == "look"'>业务员详情</span>
      <span class="ml15 card_title" v-else>{{$route.query.type == 'add' ? '添加':'修改'}}业务员</span>
    </a-card>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="dealer_name" label="所属经销商" name="dealer_name">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input readonly v-model:value="form.dealer_name" placeholder='请选择所属经销商' :disabled="$route.query.type == 'look'" />
            </a-col>
            <a-col :span="12">
              <a-button type="primary" @click='showDealer = true' :disabled="$route.query.type == 'look'">选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="store_list" label="管辖门店" name="store_list">
          <a-row :gutter="16">
            <a-col :span="12">
              <div class="storeBox m-t-5">
                <div v-if='form.store_list_name.length>0'>
                  <a-tag class='m-b-10'  v-for='(item,index) in form.store_list_name' :key='item' closable @close.prevent="preventDefault(index)" >{{item}}</a-tag>
                </div>
                <p v-else>请选择管辖门店</p>
              </div>
            </a-col>
            <a-col :span="12">
              <a-button type="primary" @click='showStore = true'  :disabled="$route.query.type == 'look'||dealer_id == null">选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="sale_name" label="业务员名称" name="sale_name">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.sale_name" placeholder='请输入业务员名称' :disabled="$route.query.type == 'look'" />
            </a-col>
            <a-col :span="12">
              <p>最多10个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="account" label="手机号码" name="account">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.account" placeholder='请输入手机号码' :disabled="$route.query.type == 'look'" />
            </a-col>
            <a-col :span="12"><p>（登陆账号）</p></a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="password" label="设置密码" name="password" v-if='$route.query.type == "add"'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input-password v-model:value="form.password" placeholder='请输入密码' :disabled="$route.query.type == 'look'" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="is_verification_order" label="核销订单" name="is_verification_order">
          <a-radio-group v-model:value="form.is_verification_order" :disabled="$route.query.type == 'look'">
            <a-radio :value="1">
              允许
            </a-radio>
            <a-radio :value="0">
              不允许
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item ref="is_check_data" label="查看数据" name="is_check_data">
          <a-radio-group v-model:value="form.is_check_data" :disabled="$route.query.type == 'look'">
            <a-radio :value="1">
              允许
            </a-radio>
            <a-radio :value="0">
              不允许
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item ref="is_store_order" label="代门店下单" name="is_store_order">
          <a-radio-group v-model:value="form.is_store_order" :disabled="$route.query.type == 'look'">
            <a-radio :value="1">
              允许
            </a-radio>
            <a-radio :value="0">
              不允许
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item ref="is_scan_warehouse_out" label="扫码出库" name="is_scan_warehouse_out">
          <a-radio-group v-model:value="form.is_scan_warehouse_out" :disabled="$route.query.type == 'look'">
            <a-radio :value="1">
              允许
            </a-radio>
            <a-radio :value="0">
              不允许
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 2 }" v-if="$route.query.type != 'look'">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect"></selectDealer>
  </a-modal>
  <a-modal  :keyboard="false" title="选择门店" centered v-model:visible="showStore" :width='1300' :footer="null" destroyOnClose>
    <selectStore v-on:select="storeSelect" :selectList='storeData' :dealer_id='dealer_id' :checkout='true' :hiddenHead='true'></selectStore>
  </a-modal>
</template>
<script>
  import { LeftOutlined } from '@ant-design/icons-vue';
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { clerkAdd, clerkEdit, getClerkMore } from '@/api/dealer'
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    dealer_name:'',
    dealer_id: '',
    store_list:[],
    store_list_name:[],
    sale_name: '',
    account: '',
    password: '',
    is_verification_order: '',
    is_store_order: '',
    is_check_data:'',
    is_scan_warehouse_out:''
  }
  export default {
    components: {
      LeftOutlined,
    },
    setup() {
      const ruleForm = ref()
      const $route = inject('$route')
      const $Modal = inject('$Modal')
      const $router = inject('$router')
      const _lodash = inject("_lodash");
      const form = ref(_lodash.cloneDeep({ ...defForm }));
      const state = reactive({
        storeData:[],
        dataSource: [],
        targetKeys: [],
        fileList: [],
        loading: false,
        showDealer: false,
        showStore: false,
        dealer_id: null,
        imageUrl: '',
        previewVisible: false,
        previewImage: '',
        labelCol: { span: 2 },
        wrapperCol: { span: 10 },
        rules: {
          dealer_name: [
            { required: true, message: '请选择所属经销商' }
          ],
          store_list: [
            { required: true, message: '请选择管辖门店' }
          ],
          sale_name: [
            { required: true, message: '请输入业务员名称' }
          ],
          account: [
            { required: true, message: '请输入手机号码' }
          ],
          password: [
            { required: true, message: '请输入密码' }
          ],
          is_verification_order: [
            { required: true, message: '请选择是否允许核销订单' }
          ],
          is_check_data: [
            { required: true, message: '请选择是否允许查看数据' }
          ],
          is_store_order: [
            { required: true, message: '请选择是否允许代门店下单' }
          ],
          is_scan_warehouse_out: [
            { required: true, message: '请选择是否允许扫码出库' }
          ],
        }
      });
      //选择经销商
      const dealerSelect = (e) => {
        if (e == 0) {
          form.value.dealer_name = '总部'
          form.value.dealer_id = e
          state.dealer_id = e
        }else{
          form.value.dealer_name = e.dealer_name
          form.value.dealer_id = e.dealer_id
          state.dealer_id = e.dealer_id
        }
        state.showDealer = false
        form.value.store_list = []
        form.value.store_list_name = []
      }
      //选择门店
      const storeSelect = (e) => {
        form.value.store_list = []
        form.value.store_list_name = []
        e.forEach(i=>{
          form.value.store_list_name.push(i.store_name)
          form.value.store_list.push(i.id)
        })
        state.storeData = e
        state.showStore = false
      }
      //
      const preventDefault = (e) =>{
        if($route.query.type == 'look'){
          return false
        }
        form.value.store_list_name.splice(e,1)
        form.value.store_list.splice(e,1)
      }
      const getMore = async(id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getClerkMore(id).then(res => res.data);
        if (iscode(res)) {
          form.value = res.data
          form.value.store_list_name = res.data.store_list_text || []
          state.dealer_id = res.data.dealer_id
          setTimeout(hide);
        } else {
          message.error(res.msg);
          setTimeout(hide);
        }
      }
      const onSubmit = () => {
        
        ruleForm.value.validate().then(async() => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if ($route.query.type == 'add') {
            res = await clerkAdd(form.value).then(res => res.data);
          } else {
            res = await clerkEdit($route.query.id,form.value).then(res => res.data);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1)
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        if ($route.query.type == 'edit' || $route.query.type == 'look') {
          getMore($route.query.id);
        }
      })
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        storeSelect,
        dealerSelect,
        getMore,
        preventDefault
      }
    }
  }
</script>
<style lang="less" scoped>
.storeBox{
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  padding: 4px 11px;
    line-height: 1.5715;
}
</style>